import { A } from "@solidjs/router";
import { For, Show } from "solid-js";
import { relativeAge } from "../../ui/format";
import { createRunOutput } from "./playgroundQueries";
import { RunOutputPanel } from "./RunOutputPanel";

/** Single playground run, full width. The result body is the same
 * RunOutputPanel each compare column renders, so the two never drift. */
export function PlaygroundRunDetail(props: {
  websiteId: string;
  runId: string;
}) {
  const output = createRunOutput(
    () => props.websiteId,
    () => props.runId,
  );

  return (
    <main class="landing">
      <div class="landing-bar">
        <A href={`/playground/w/${props.websiteId}`} class="landing-brand">
          ← Back to experiment
        </A>
      </div>
      <div class="landing-main pg-wide">
        <Show
          when={output.data}
          fallback={<div class="loading">Loading run…</div>}
        >
          {(data) => {
            const run = () => data().run;
            return (
              <>
                <div class="landing-head-row">
                  <div>
                    <h1 class="landing-h1 mono">{data().url}</h1>
                    <p
                      class="landing-sub"
                      style={{
                        display: "flex",
                        gap: "6px",
                        "flex-wrap": "wrap",
                        "align-items": "center",
                      }}
                    >
                      <span class="badge">{run().status}</span>
                      <span>{relativeAge(run().startedAt)}</span>
                      <For each={runFacts(run())}>
                        {(fact) => <span class="badge">{fact}</span>}
                      </For>
                    </p>
                    <Show when={run().error}>
                      <p class="landing-sub badge-sev sev-critical">
                        {run().error}
                      </p>
                    </Show>
                  </div>
                </div>
                <RunOutputPanel data={data()} runId={props.runId} />
              </>
            );
          }}
        </Show>
      </div>
    </main>
  );
}

function runFacts(run: {
  promptBundleLabel: string | null;
  catalogDraftLabel: string | null;
  tovVersionId: string | null;
  humanScore: number | null;
  agentScore: number | null;
}): string[] {
  return [
    `prompt: ${run.promptBundleLabel ?? "active"}`,
    `catalog: ${run.catalogDraftLabel ?? "canonical"}`,
    `voice: ${run.tovVersionId ? "on" : "none"}`,
    `human: ${run.humanScore ?? "—"}`,
    `agent: ${run.agentScore ?? "—"}`,
  ];
}
